import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'
import RssFeeds from './components/RssFeeds'
import SportsGames from './components/SportsGames'
import Weather from './components/Weather'
import Transit from './components/Transit'
import VideoWeather from './components/VideoWeather'
import EventSlide from './components/EventSlide'

Vue.use(VueRouter)
Vue.config.productionTip = false

const routes = [
  { path: '/', component: RssFeeds, props: { isAretv: false } },
  { path: '/aretv/news', component: RssFeeds, props: true },
  { path: '/aretv/sports-games', component: SportsGames, props: true },
  { path: '/aretv/weather', component: Weather, props: true },
  { path: '/aretv/video-weather', component: VideoWeather, props: true },
  { path: '/aretv/transit', component: Transit, props: true },
  { path: '/aretv/event', component: EventSlide, props: true }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
